module.exports = __webpack_public_path__ + "static/media/loop-studios.6c50fd74.svg";